import { Input } from './input'
import { Label } from './label'

interface RangeInputProps {
  label?: string
  minValue: string
  maxValue: string
  onMinChange: (value: string) => void
  onMaxChange: (value: string) => void
  minLabel?: string
  maxLabel?: string
  className?: string
}

export function RangeInput({
  label,
  minValue,
  maxValue,
  onMinChange,
  onMaxChange,
  minLabel = '最小',
  maxLabel = '最大',
  className = '',
}: RangeInputProps) {
  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && <Label className="text-xs text-muted-foreground">{label}</Label>}
      <div className="flex items-center gap-2">
        <Input
          type="number"
          value={minValue}
          onChange={(e) => onMinChange(e.target.value)}
          placeholder={minLabel}
          className="h-8 flex-1"
        />
        <span className="text-muted-foreground">-</span>
        <Input
          type="number"
          value={maxValue}
          onChange={(e) => onMaxChange(e.target.value)}
          placeholder={maxLabel}
          className="h-8 flex-1"
        />
      </div>
    </div>
  )
}



